import Vue from 'vue'
import VueRouter from 'vue-router'
import { BASE_URL, mode } from '@/utils/'
import routes, { beforeEach, scrollBehavior } from './all-routes';

Vue.use(VueRouter)

const router = new VueRouter({
    mode,
    base: BASE_URL,
    routes: routes.index,
    scrollBehavior,
})

router.beforeEach(beforeEach('index'))

export default router
